/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberCategories } from '../../models/member-categories';

export interface GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Params {
  org: string;
}

export function getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet(http: HttpClient, rootUrl: string, params: GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberCategories>>> {
  const rb = new RequestBuilder(rootUrl, getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet.PATH, 'get');
  if (params) {
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MemberCategories>>;
    })
  );
}

getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet.PATH = '/api/v2/secretariat/members/categories/all';
